import React from 'react'
import Button from '@mui/material/Button'
import {styled} from '@mui/material/styles'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import Typography from '@mui/material/Typography'
import useUnlockContentDialog from 'logic/Display/useUnlockContentDialog.js'

const UnlockContentDialog = () => {
    const {
        isRtl,
        open,
        handleClose,
        handleLoginOrRegisterClick,
        headerText,
        p1Text,
        p2Text,
        loginOrRegisterText,
    } = useUnlockContentDialog()

    return (
        <BootstrapDialog
            onClose={handleClose}
            open={open}
            dir={isRtl ? 'rtl' : 'ltr'}>
            <DialogTitleStyled>{headerText}</DialogTitleStyled>
            <IconButtonStyled aria-label="close" onClick={handleClose}>
                <CloseIcon />
            </IconButtonStyled>
            <DialogContentStyled dividers>
                <Typography gutterBottom>{p1Text} </Typography>
                <Typography gutterBottom>{p2Text}</Typography>
            </DialogContentStyled>
            <DialogActionsStyled>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={handleLoginOrRegisterClick}>
                    {loginOrRegisterText}
                </Button>
            </DialogActionsStyled>
        </BootstrapDialog>
    )
}

export default UnlockContentDialog

const BootstrapDialog = styled(Dialog)`
    & .MuiDialog-paper {
        margin-top: ${({theme}) => theme.spacing(2)}px;
        transform: translateY(-50%);
    }

    & .MuiDialogContent-root {
        padding: ${({theme}) => theme.spacing(2)}px;
    }

    & .MuiDialogActions-root {
        padding: ${({theme}) => theme.spacing(1)}px;
    }
`

const DialogTitleStyled = styled(DialogTitle)`
    margin: 0;
    padding: ${({theme}) => theme.spacing(2)}px;
`

const IconButtonStyled = styled(IconButton)`
    position: absolute;
    right: 8px;
    top: 8px;
    color: ${({theme}) => theme.palette.grey[500]};
`

const DialogContentStyled = styled(DialogContent)`
    padding: ${({theme}) => theme.spacing(2)}px;
`

const DialogActionsStyled = styled(DialogActions)`
    padding: ${({theme}) => theme.spacing(1)}px;
`
